import React, { useState } from 'react';
import Link from 'next/link';
import classNames from 'classnames';

import { Element } from 'domhandler/lib/node';
import { Button } from '@lifepal/lifepal-design-system';

import styles from './TOC.module.scss';

interface TOCProps {
  content: any | Element;
  slug: string;
  isV2?: boolean;
}

const TOC = (props: TOCProps) => {
  const [collapse, setCollapse] = useState(false);
  const { content, slug, isV2 } = props;

  const parseChildrenTOC = (element, index) => {
    return (
      <li className={styles[isV2 && index % 2 && 'dark']} key={index}>
        {isV2 && <span>{index + 1}</span>}
        <Link
          href={`/[slug]}`}
          as={`/${encodeURIComponent(slug)}${element.children[0].attribs.href}`}
          scroll={false}
        >
          <a title={element.children[0].children[0].data.trim()}>
            {element.children[0].children[0].data}
          </a>
        </Link>
      </li>
    );
  };

  const parseTOC = (element) => {
    return element.children[0].children.map((child, i) => {
      if (child.name === 'ul') return <ul key={i}> {parseTOC(element.children[0])}</ul>;
      else if (child.name === 'li') return parseChildrenTOC(child, i);
    });
  };

  return (
    <div className={styles[isV2 ? 'toc2' : 'toc']}>
      <div className={styles[isV2 ? 'toc2__header' : 'toc__header']}>
        {isV2 && <div className={styles.toc2__headerNum}>No</div>}
        <div className={styles[isV2 ? 'toc2__title' : 'toc__title']}>Daftar Isi</div>
        <Button
          type="button"
          variant="default"
          size="small"
          aria-label="Collapse Button"
          onClick={() => setCollapse(!collapse)}
        >
          {isV2 ? (
            <i className={`iconSprites ${collapse ? 'iconSprites-minus' : 'iconSprites-plus'}`} />
          ) : (
            <i
              className={`iconSprites ${
                collapse ? 'iconSprites-arrowLeft-blueSmall' : 'iconSprites-arrowRight-blueSmall'
              }`}
            />
          )}
        </Button>
      </div>
      <div
        className={classNames(
          styles[isV2 ? 'toc2__content' : 'toc__content'],
          collapse
            ? styles[isV2 ? 'toc2__hide' : 'toc__hide']
            : styles[isV2 ? 'toc2__show' : 'toc__show'],
        )}
      >
        {isV2 ? <ul>{parseTOC(content)}</ul> : <ol>{parseTOC(content)}</ol>}
      </div>
    </div>
  );
};

export default TOC;
